import getCircuitCurrentRoundIndexWorkoutSectionSelect from '../get-circuit-current-round-index'
import { getCircuitRoundsWorkoutSectionSelector } from '../get-circuit-data'
import { createSelector } from 'reselect'

export function getCurrentRoundWorkoutSectionSelector (paramRoundIndex) {
  return createSelector(
    getCircuitRoundsWorkoutSectionSelector,
    getCircuitCurrentRoundIndexWorkoutSectionSelect,
    (circuitRounds, currentRoundIndex) => {
      if (circuitRounds) {
        return circuitRounds[paramRoundIndex != null
          ? paramRoundIndex
          : currentRoundIndex]
      }
    }
  )
}
